import React, { useState } from 'react';
import cx from 'classnames';

import { OwnershipCard } from '.';

interface Props {
    roleType: ProRoleType;
    shares: WorkDetailPercentShare[];
}

const showMoreButtonClasses = 'h-6 px-3 rounded-full font-semibold text-xs';

export const OwnershipSection = ({ roleType, shares }: Props): JSX.Element => {
    const [showMore, setShowMore] = useState(false);
    const firstTwo = shares.slice(0, 2);
    const secondTwo = shares.slice(2, 4);
    const rest = shares.slice(4);
    const moreLength = secondTwo.length + rest.length;

    return (
        <div className="pr-2">
            <div className="flex justify-between text-xs text-tertiary-400 tracking-widest font-semibold mb-3">
                <div>{roleType.toUpperCase()}</div>
                {moreLength > 0 && (
                    <div className="mx-2 flex-none">
                        {!showMore && (
                            <button
                                type="button"
                                className={cx(
                                    showMoreButtonClasses,
                                    'bg-primary-100 text-primary-500',
                                )}
                                onClick={(): void => {
                                    setShowMore(true);
                                }}
                            >
                                {`+${moreLength} more`}
                            </button>
                        )}
                        {showMore && (
                            <button
                                type="button"
                                className={cx(
                                    showMoreButtonClasses,
                                    'bg-secondary-100 text-secondary-500',
                                )}
                                onClick={(): void => {
                                    setShowMore(false);
                                }}
                            >
                                Hide
                            </button>
                        )}
                    </div>
                )}
            </div>
            <div
                className={cx('grid w-full', {
                    'overflow-y-auto': showMore,
                })}
                style={{
                    gridTemplateColumns: '50% 50%',
                    maxHeight: 135,
                }}
            >
                {firstTwo.map(
                    (
                        {
                            key,
                            entity_name,
                            entity_pro,
                            percent_share,
                            sendInvite,
                            title,
                            trqkSongId,
                        }: WorkDetailPercentShare,
                        index: number,
                    ): JSX.Element => (
                        <div
                            key={key}
                            style={{
                                gridArea: `1 / ${index + 1} / 1 / ${index + 1}`,
                            }}
                        >
                            <OwnershipCard
                                enableSendInvite={sendInvite}
                                name={entity_name}
                                percent_share={percent_share}
                                pro={entity_pro}
                                title={title}
                                trqkSongId={trqkSongId}
                            />
                        </div>
                    ),
                )}

                {secondTwo.length > 0 && showMore && (
                    <>
                        {secondTwo.map(
                            (
                                {
                                    key,
                                    entity_name,
                                    entity_pro,
                                    percent_share,
                                    sendInvite,
                                    title,
                                    trqkSongId,
                                }: WorkDetailPercentShare,
                                index: number,
                            ): JSX.Element => (
                                <div
                                    key={key}
                                    style={{
                                        gridArea: `2 / ${index + 1} / 2 / ${
                                            index + 1
                                        }`,
                                    }}
                                >
                                    <OwnershipCard
                                        enableSendInvite={sendInvite}
                                        key={key}
                                        name={entity_name}
                                        percent_share={percent_share}
                                        pro={entity_pro}
                                        title={title}
                                        trqkSongId={trqkSongId}
                                    />
                                </div>
                            ),
                        )}
                    </>
                )}
                {rest.length > 0 && (
                    <>
                        {showMore && (
                            <>
                                {rest.map(
                                    (
                                        {
                                            key,
                                            entity_name,
                                            entity_pro,
                                            percent_share,
                                            sendInvite,
                                            title,
                                            trqkSongId,
                                        }: WorkDetailPercentShare,
                                        index: number,
                                    ): JSX.Element => {
                                        const gridRow =
                                            2 + Math.ceil((index + 1) / 2);
                                        const gridColumn = (index % 2) + 1;

                                        return (
                                            <div
                                                key={key}
                                                style={{
                                                    gridRow,
                                                    gridColumn,
                                                }}
                                            >
                                                <OwnershipCard
                                                    enableSendInvite={
                                                        sendInvite
                                                    }
                                                    name={entity_name}
                                                    percent_share={
                                                        percent_share
                                                    }
                                                    pro={entity_pro}
                                                    title={title}
                                                    trqkSongId={trqkSongId}
                                                />
                                            </div>
                                        );
                                    },
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
